import { ReactElement, SVGProps } from 'react';
import { ReactComponent as EuropeIconComponent } from './europe-icon.svg';

export const EuropeIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <EuropeIconComponent {...props} />;
};
